module.exports = __webpack_public_path__ + "static/img/9.0c1be4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/9.png
// module id = VNz7
// module chunks = 0